///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2026
//                                    RXO Inc.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of RXO Inc. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { times } from "lodash";

import TableHeader from "./TableHeader";

function Loader({ isFetching }) {
  const BodyCell = () => (
    <td className="body-cell truncate content-placeholder py-16 px-8 align-middle">
      <span></span>
    </td>
  );

  return (
    <table className="one-whole bids-grid" data-testid="loader">
      <TableHeader isFetching={isFetching} />
      <tbody>
        {times(12, index => {
          return (
            <tr className="row bg-white" key={index}>
              {times(10, index => (
                <BodyCell key={index} />
              ))}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

export default Loader;
